
/* styles */
require("!!vue-style-loader!css-loader?sourceMap!../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-ef06a532\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./notetasklist.vue.html")

var Component = require("!../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!awesome-typescript-loader?silent=true!./notetasklist.ts"),
  /* template */
  require("!!../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-ef06a532\"}!../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./notetasklist.vue.html"),
  /* scopeId */
  "data-v-ef06a532",
  /* cssModules */
  null
)
Component.options.__file = "C:\\_Team\\_Net\\Web\\AuxiliumSolution\\Auxilium.APP\\ClientApp\\src\\portalhome\\docketing\\pages\\hearingdetails\\notetask\\notetasklist.vue.html"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] notetasklist.vue.html: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ef06a532", Component.options)
  } else {
    hotAPI.reload("data-v-ef06a532", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./ClientApp/src/portalhome/docketing/pages/hearingdetails/notetask/notetasklist.vue.html
// module id = 577
// module chunks = 0